import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=3c963c16&"
import script from "./ListComponent.vue?vue&type=script&lang=js&"
export * from "./ListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports